import React from 'react';
import PropTypes from 'prop-types';
import { AdminNavTab } from './components/AdminNavTab';

export class AdminNavbar extends React.Component {
  render() {
    const { currentPage } = this.props;
    return <nav className='nav has-shadow is-admin'>
      <div className='container'>
        <div className='nav-left'>
          <a className='nav-item'>Administration:</a>
          <AdminNavTab
            url='/categoryManagement'
            text='Categories'
            isActive={currentPage === 'categoryManagement'} />
          <AdminNavTab
            url='/tagManagement'
            text='Tags'
            isActive={currentPage === 'tagManagement'} />
          <AdminNavTab
            url='/userManagement'
            text='Users'
            isActive={currentPage === 'userManagement'} />
          <AdminNavTab
            url='/documentManagement'
            text='Documents'
            isActive={currentPage === 'documentManagement'} />
          <AdminNavTab
            url='/report'
            text='Reports'
            isActive={currentPage === 'report'} />
        </div>
      </div>
    </nav>;
  }
}

AdminNavbar.propTypes = {
  currentPage: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/common/components/adminNavbar/AdminNavbar.jsx